import { CustomKeyAttributes } from '@loyalty/shared-common/profile-api-client';
import { Fields } from '@react-awesome-query-builder/core';
import { BaseConfigSettings } from '../fields';
import { profileFields } from './profile-fields';
import { shouldBeApositiveNumber } from './should-be-apositive-number';

export function qualifioLoyaltyBirthday(
  settings: BaseConfigSettings,
  customKeys?: CustomKeyAttributes[],
): Fields {
  const { t } = settings;
  return {
    event: {
      label: t('rule.criteria.event'),
      type: '!group',
      subfields: {
        age: {
          label: t('rule.criteria.birthday.age'),
          type: 'number',
          fieldSettings: {
            validateValue: shouldBeApositiveNumber,
          },
          valueSources: ['value'],
        },
        timestamp: {
          label: t('rule.criteria.date'),
          type: 'date',
          preferWidgets: ['date'],
        },
      },
    },
    profile: {
      label: t('rule.criteria.profile'),
      type: '!group',
      subfields: profileFields(settings, customKeys),
    },
  };
}
